import { ca } from '@cian/analytics';

import { EPromoType, IPromoInfoSchema } from '../../repositories/newbuilding-card/entities/promo/PromoInfoSchema';
import { getNewbuildingProduct } from '../../utils/analytics';

export function trackShowPhoneClick(gaLabel: string, promo: IPromoInfoSchema, newbuildingId: number) {
  const { promoType, promoId } = promo;

  const isMortgage = [
    EPromoType.Mortgage,
    EPromoType.CianMortgage,
    EPromoType.MilitaryMortgage,
    EPromoType.Bank,
  ].includes(promo.promoType);

  ca('eventSite', {
    action: isMortgage ? 'Open_jk_mortgage' : 'Open_jk_promotions',
    category: 'Phones',
    label: gaLabel,
    name: 'oldevent',
    products: [getNewbuildingProduct({ newbuildingId, extra: { label: promoType, promotion_id: promoId } })],
  });
}
